// 이메일 형식: 일반적인 이메일 유효성 검사
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
/** 비밀번호 형식: 영문, 숫자, 특수문자 중 2종류 이상 조합 8자리 이상 입력 */
export const PASSWORD_REGEX =
  /^(?=.{8,}$)(?:(?=.*[a-zA-Z])(?=.*\d)|(?=.*[a-zA-Z])(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~])|(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~])).*$/;
